import React, { FC, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
  Summary,
  TotalItem,
} from 'devextreme-react/data-grid';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { MONEY_FORMAT } from 'constants/formats';
import { useAuth } from 'context/auth';
import { Button, Template } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { CreateEditModal, DeleteModal } from './components';

const DriverSalaryAdjustments: FC = () => {
  const history = useHistory();
  const { getClaims }: any = useAuth();

  const [adjustmentId, setAdjustmentId] = useState<number | null>(null);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);

  const driverSalaryAdjustmentsStore: any = useMemo(() => {
    return $createStore('/v1/DriverMixerAdjustments/', 'id');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);
  const refreshGrid = () => refGrid.current?.instance.refresh();

  const onRowDblClickHandler = ({ data }: any) => {
    if (getClaims(['CanLookMixerAdjustmentsDetails'])) {
      history.push(`salary-mixer-adjustment/${data.id}`);
    }
  };

  return (
    <div className="container-dev">
      <AppLayoutTop title="">
        <ClaimsProvider claimsBlock={['CanCreateMixerAdjustments']}>
          <Button
            width={120}
            text="Создать"
            type="default"
            onClick={() => {
              setAdjustmentId(null);
              setVisibleModal(true);
            }}
          />
        </ClaimsProvider>
      </AppLayoutTop>
      <CreateEditModal
        changeVisible={setVisibleModal}
        id={adjustmentId}
        refresh={refreshGrid}
        visible={visibleModal}
        type="mixer"
      />
      <DeleteModal
        changeVisible={setVisibleDeleteModal}
        id={adjustmentId}
        refresh={refreshGrid}
        visible={visibleDeleteModal}
      />
      <AppCard>
        <DataGrid
          dataSource={driverSalaryAdjustmentsStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={refGrid}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          onRowDblClick={onRowDblClickHandler}
          onToolbarPreparing={(e) => {
            e.toolbarOptions?.items?.unshift({
              location: 'after',
              template: 'refresh',
            });
          }}
        >
          <StateStoring enabled={true} type="localStorage" storageKey="driverSalaryAdjustments" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Template name="refresh">
            <Button icon="refresh" onClick={refreshGrid} />
          </Template>

          <Column dataField="id" caption="Номер" width={80} />
          <Column dataField="date" dataType="date" caption="Дата" width={120} />
          <Column dataField="driverName" caption="Водитель" />
          <Column dataField="sum" caption="Сумма руб." format={MONEY_FORMAT} />
          <Column dataField="comment" caption="Комментарий" />
          <Column
            dataField=""
            cellRender={({ data }) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditMixerAdjustments']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setAdjustmentId(data.id);
                      setVisibleModal(true);
                    }}
                  />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteMixerAdjustments']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setVisibleDeleteModal(true);
                      setAdjustmentId(data.id);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />

          <Export enabled={true} />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
          <Summary>
            <TotalItem column="count" summaryType="sum" displayFormat="Итого: {0}" />
          </Summary>
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default DriverSalaryAdjustments;
